module.exports = __webpack_public_path__ + "img/close-icon.f3ef19b8.svg";